import { useMatomo } from '@mitresthen/matomo-tracker-react';
import { type TrackEventParams } from '@mitresthen/matomo-tracker-react/src/types';

export const useDataBoxMatomo = () => {
	const { trackEvent: trackEventBase } = useMatomo();

	const trackEvent = (params: Omit<TrackEventParams, 'category'>) => {
		trackEventBase({ ...params, category: 'datove_schranky' });
	};

	return { trackEvent };
};
